export const IMAGE_TYPE_CLASS = 'image';
export const DEFAULT_TYPE_CLASS = 'default';

// export const FALLBACK_IMAGE = '/assets/fallback/office.jpeg';

// export const FALLBACK_COLOR = '#05f';